const waterPurifierRepairService = {
  title: "Water Purifier Repair",
  icon: "🚰",
  rateCardKey: "water-purifier",
  shortDescription:
    "Filter issue, low water flow, leakage, servicing, and purifier setup support.",
  longDescription:
    "Book water purifier support for flow issues, servicing, leakage, filter-side problems, and installation assistance.",
  consultationNote:
    "RO membrane, motor, PCB, or advanced purification faults may require inspection and part-based pricing.",
  responsePromise:
    "Assignment depends on purifier type, issue nature, and technician coverage.",
  warrantyPolicy:
    "Support depends on cartridge condition, part usage, and repair scope.",
  subServices: [
    {
      id: "wp-inspection",
      title: "Purifier Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for no water flow, low output, leakage, or taste-quality issues.",
      basePrice: 249,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "wp-servicing",
      title: "Basic Purifier Servicing",
      icon: "🧼",
      group: "Service",
      description:
        "Basic cleaning and service support for purifier system upkeep.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "45-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "wp-leakage-issue",
      title: "Leakage Issue Support",
      icon: "💧",
      group: "Repair",
      description:
        "Check and basic repair support for purifier-side leakage symptoms.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "wp-installation",
      title: "Purifier Installation",
      icon: "🧰",
      group: "Installation",
      description:
        "Basic purifier installation and connection support.",
      basePrice: 599,
      priceType: "starts_at",
      duration: "45-75 mins",
      warranty: "7 days",
      unit: "job",
    },
  ],
};

export default waterPurifierRepairService;